
    import * as React from 'react';

    const Tag12 = ({ color = 'currentcolor', height = '12px', width = '12px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 12 12" style={svgStyle}><path d="M5.5 3.5a2 2 0 11-4 .002 2 2 0 014-.001zm-.75 0a1.25 1.25 0 10-2.5 0 1.25 1.25 0 002.5 0zm5.75 0a2 2 0 11-4 .002 2 2 0 014-.001zm-.75 0a1.25 1.25 0 10-2.5 0 1.25 1.25 0 002.5 0zm.75 5a2 2 0 11-4 .002 2 2 0 014-.001zm-.75 0a1.25 1.25 0 10-2.5 0 1.25 1.25 0 002.5 0zm-4.25 0a2 2 0 11-4 .002 2 2 0 014-.001zm-.75 0a1.25 1.25 0 10-2.5 0 1.25 1.25 0 002.5 0z" /></svg>
        </div>
      );
    };

    Tag12.displayName = 'Tag12';

    export default Tag12;
  